import {SET_DATA_REMOVE_LOT_MODAL} from "../../types";

export function setParams(data) {
    return (dispatch) => {
        dispatch({type: SET_DATA_REMOVE_LOT_MODAL, payload: data});
    }
}